import React from 'react';
import { Layout } from 'features/common/components/Layout';
import InvoicePdfViewer from './components/InvoicePdfViewer';

export const InvoiceDetailPage = (): JSX.Element => {
	return (
		<Layout>
			<InvoicePdfViewer />
		</Layout>
	);
};
